import { PageUtils } from "./helpers/page-utils";
const _throttle = require('lodash.throttle');
const _debounce = require('lodash.debounce');

window.addEventListener('load', event => {
    // Mobile nav
    const siteHeader = document.getElementById('siteHeader');
    const mobileNavToggle = document.getElementById('mobileNavToggle');
    const mobileNavigation = document.getElementById('mobileNavigation');
    const mobileNavDropdownToggle = document.querySelectorAll('.mobile-nav-dropdown-toggle');

    let open = false;
    let locked = false;

    if (mobileNavToggle && mobileNavigation) {
        mobileNavToggle.addEventListener('click', () => {
            if (!locked) {
                if (!!open) {
                    closeMobileNav()
                } else {
                    openMobileNav();
                }
            }
        });

        // Desktop nav
        let desktopNavDropdownContent = document.querySelectorAll('.desktop-nav-dropdown-content');

        // Keeps land dropdown nav hidden for 500ms on page load to mask transitions
        for (let navDropdown of desktopNavDropdownContent) {
            setTimeout(function() {
                navDropdown.classList.remove('hidden');
            }, 500);
        }

        function openMobileNav() {
            if (!open) {
                mobileNavToggle.classList.add('active');
                mobileNavigation.classList.add('active');

                // wait til nav is fully open before marking as open and lock until complete
                locked = true;
                setTimeout(() => {
                    PageUtils.bodyLockToggleOn();
                    open = true;
                    locked = false;
                    startListening();
                }, 500);

                for (let navDropdown of mobileNavDropdownToggle) {
                    let mobileNavDropdownContent = navDropdown.closest('li').nextElementSibling;
                    navDropdown.addEventListener('click', () => {
                        navDropdown.querySelector('svg').classList.add('-scale-x-100');
                        mobileNavDropdownContent.classList.remove('!max-h-0');
                        mobileNavDropdownContent.classList.add('opacity-100');
                    });
                }
            }
        }

        function closeMobileNav() {
            if (!!open) {
                open = false;
                mobileNavToggle.classList.remove('active');
                mobileNavigation.classList.remove('active');
                PageUtils.bodyLockToggleOff();
                stopListening();

                for (let navDropdown of mobileNavDropdownToggle) {
                    let mobileNavDropdownContent = navDropdown.closest('li').nextElementSibling;
                    navDropdown.querySelector('svg').classList.remove('-scale-x-100');
                    mobileNavDropdownContent.classList.add('!max-h-0');
                    mobileNavDropdownContent.classList.remove('opacity-100');
                }
            }
        }

        function startListening() {
            window.addEventListener('click', clickListener);
            window.addEventListener('resize', resizeListener);
        }

        function stopListening() {
            window.removeEventListener('click', clickListener);
            window.removeEventListener('resize', resizeListener);
        }

        // Throttle for resize listener to close open menus on page resize
        const closeNavResizeThrottle = _throttle(resizeCloseNav, 50, {leading: true, trailing: true});

        function resizeCloseNav() {
            let windowSize = window.innerWidth;
            setTimeout(() => {
                if (windowSize !== window.innerWidth) {
                    closeMobileNav();
                }
            }, 50);
        }

        // Debounce for click listener to close open menus if click is not inside menu
        const closeNavClickDebounce = _debounce(clickOutsideCloseNav, 50, {leading: true, trailing: true});

        function clickOutsideCloseNav(event) {
            if (!siteHeader.contains(event.target)) {
                closeMobileNav();
            }
        }

        const resizeListener = () => {
            closeNavResizeThrottle();
        };

        const clickListener = (event) => {
            closeNavClickDebounce(event);
        };
    }
});
